import { createFileRoute } from '@tanstack/react-router';

import { CrewDetailPage } from '@/features/workforce/crew-detail-page';

export const Route = createFileRoute('/_app/projects/$projectId/workforce/crew/$engagementId')({
  component: CrewDetailRoute,
});

function CrewDetailRoute() {
  const { projectId, engagementId } = Route.useParams();
  return <CrewDetailPage projectId={projectId} engagementId={engagementId} />;
}
